import { render } from "./Terms.vue?vue&type=template&id=89b73472&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=89b73472&scoped=true&lang=css"
import "./Terms.vue?vue&type=style&index=1&id=89b73472&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b73472"]])

export default __exports__